module.exports = __webpack_public_path__ + "static/media/cloud.47e8fbe6.svg";